/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Access Administration API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Create role
 */

export const CreateAccessAdministrationRoleBody = zod.object({
  name: zod.string().min(1),
  description: zod.string().optional(),
  parentRoleId: zod.uuid().optional(),
});

export const CreateAccessAdministrationRoleResponse = zod.uuid();

/**
 * @summary List roles
 */

export const listAccessAdministrationRolesQueryPerPageMax = 100;

export const ListAccessAdministrationRolesQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listAccessAdministrationRolesQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce.string().optional().describe("Free-text search query"),
});

export const listAccessAdministrationRolesResponseMetaTotalMin = 0;

export const ListAccessAdministrationRolesResponse = zod.object({
  items: zod.array(
    zod.object({
      roleId: zod.uuid(),
      name: zod.string(),
      description: zod.string(),
      parentRole: zod
        .union([
          zod.object({
            roleId: zod.uuid(),
            name: zod.string(),
          }),
          zod.null(),
        ])
        .optional(),
      directPermissions: zod.array(
        zod.object({
          permissionKey: zod.string(),
          label: zod.string(),
          description: zod.string(),
          category: zod.string(),
        }),
      ),
      inheritedPermissions: zod.array(
        zod.object({
          permissionKey: zod.string(),
          label: zod.string(),
          description: zod.string(),
          category: zod.string(),
        }),
      ),
      effectivePermissions: zod.array(
        zod.object({
          permissionKey: zod.string(),
          label: zod.string(),
          description: zod.string(),
          category: zod.string(),
        }),
      ),
    }),
  ),
  meta: zod.object({
    total: zod
      .int()
      .min(listAccessAdministrationRolesResponseMetaTotalMin)
      .describe("Total count of items matching query ignoring pagination"),
    page: zod.int().min(1).describe("Current page number"),
    perPage: zod.int().min(1).describe("Number of items returned per page"),
  }),
});

/**
 * @summary Assign permission to role
 */

export const AssignAccessAdministrationRolePermissionBody = zod.object({
  permissionKey: zod.string().min(1),
});

export const AssignAccessAdministrationRolePermissionResponse = zod.void();

/**
 * @summary Remove permission from role
 */
export const RemoveAccessAdministrationRolePermissionResponse = zod.void();

/**
 * @summary Get role
 */
export const GetAccessAdministrationRoleResponse = zod.object({
  roleId: zod.uuid(),
  name: zod.string(),
  description: zod.string(),
  parentRole: zod
    .union([
      zod.object({
        roleId: zod.uuid(),
        name: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
  directPermissions: zod.array(
    zod.object({
      permissionKey: zod.string(),
      label: zod.string(),
      description: zod.string(),
      category: zod.string(),
    }),
  ),
  inheritedPermissions: zod.array(
    zod.object({
      permissionKey: zod.string(),
      label: zod.string(),
      description: zod.string(),
      category: zod.string(),
    }),
  ),
  effectivePermissions: zod.array(
    zod.object({
      permissionKey: zod.string(),
      label: zod.string(),
      description: zod.string(),
      category: zod.string(),
    }),
  ),
});
